import styled from "styled-components";
import { theme } from "../../../../../helpers/theme";

export interface AdditionalRemarksProps {
    data: string,
}

export const AdditionalRemarks = (props: AdditionalRemarksProps) => {
    return (
        <>
            <Title>Dodatkowe uwagi:</Title>
            <Description>
                {props?.data ? props.data : "(Brak dodatkowych uwag)"}
            </Description>
        </>
    );
};

const Title = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.big};
font-size: 16px;
line-height: 24px;
color: ${theme.colors.black_primaryText};
padding-bottom:12px;
`;
const Description = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.small};
font-size: 14px;
line-height: 20px;
color: ${theme.colors.gray01_secondaryText};
padding-bottom:24px;
`;
